<template>
  <div>
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Book ID"
            label-for="vi-book-id"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-book-id"
                v-model="sequence.bookId"
                placeholder="Book ID"
                disabled="disabled"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Chapter"
            label-for="vi-book-chapter"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="HashIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-book-chapter"
                v-model="sequence.chapter"
                placeholder="Chapter number"
                disabled="disabled"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="FEN"
            label-for="vi-fen"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-fen"
                v-model="sequence.fen"
                placeholder="FEN"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <chessboard :fen="sequence.fen" />
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Level"
            label-for="vi-level"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="EditIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="sequence.level"
                :options="levels"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="User Color"
            label-for="vi-user-color"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="EditIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="sequence.userColor"
                :options="userColors"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Notation"
            label-for="vi-solution"
          >
            <b-input-group class="input-group-merge">
              <b-form-textarea
                id="vi-solution"
                v-model="sequence.notation"
                placeholder="Solution"
                rows="3"
                max-rows="6"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="1">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="saveSequence"
          >
            Save
          </b-button>
        </b-col>
        <b-col cols="1">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mr-1"
            @click="askDelete"
          >
            Delete
          </b-button>
        </b-col>
        <b-col cols="1">
          <div style="margin-left: 5px;margin-top: 3px">
            <b-spinner
              :style="{ display: showLoading }"
              type="grow"
            />
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend, BSpinner, BFormSelect, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { chessboard } from 'vue-chessboard'
import 'vue-chessboard/dist/vue-chessboard.css'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BSpinner,
    BFormSelect,
    chessboard,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      sequence: {},
      showLoading: 'none',
      levels: [
        { value: null, text: 'Please select an level' },
        { value: 0, text: 'EASY' },
        { value: 1, text: 'MODERATE' },
        { value: 2, text: 'HARD' },
        { value: 3, text: 'VERY_HAR' },
      ],
      userColors: [
        { value: null, text: 'Please select user color' },
        { value: 0, text: 'WHITE' },
        { value: 1, text: 'BLACK' },
      ],
    }
  },
  mounted() {
    const url = `${this.$readerURL}/admin/sequence/${this.$route.params.id}`
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.loader('none')
        this.sequence = response.data
        return response
      }).catch(error => {
        console.log(error)
        this.loader('none')
      })
    })
  },
  methods: {
    askDelete() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this sequence?.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          console.log(value)
          if (value) {
            this.deleteSequence()
          }
        })
    },
    deleteSequence() {
      const url = `${this.$readerURL}/admin/sequence/${this.$route.params.id}`
      console.log(url)
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$router.push('/learning')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    saveSequence() {
      const url = `${this.$readerURL}/admin/sequence/${this.$route.params.id}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.sequence,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.sequence = response.data
          this.loader('none')

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          console.log(error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
